import * as types from "@/store/types";
const token = `Bearer ${window.localStorage.getItem(types.GLOBAL_USER_TOKEN)}`;
export default token;
